import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronDownRegular } from "@fluentui/react-icons/svg/chevron-down";
import { ChevronUpRegular } from "@fluentui/react-icons/svg/chevron-up";

export interface SidebarShowMoreProps {
  /** How many rows are currently hidden. */
  hiddenCount: number;
  isExpanded: boolean;
  isCollapsed: boolean;
  onToggle: () => void;
}

/**
 * Reveals the rest of a filter section.
 *
 * A board with twenty connections and thirty tags turns the pane into a
 * scrolling wall, so each section shows its busiest few and keeps the rest
 * behind this.
 */
const SidebarShowMore: React.FC<SidebarShowMoreProps> = ({
  hiddenCount,
  isExpanded,
  isCollapsed,
  onToggle,
}) => {
  const { t } = useTranslation();

  if (hiddenCount <= 0 && !isExpanded) {
    return null;
  }

  const label = isExpanded
    ? t("layout.sidebar.showLess")
    : t("layout.sidebar.showMore", { count: hiddenCount });

  return (
    <button
      type="button"
      className="sidebar-nav__link sidebar-nav__link--compact sidebar-nav__show-more"
      onClick={onToggle}
      title={label}
      aria-label={label}
      aria-expanded={isExpanded}
    >
      {isExpanded ? (
        <ChevronUpRegular className="sidebar-nav__show-more-icon" />
      ) : (
        <ChevronDownRegular className="sidebar-nav__show-more-icon" />
      )}
      {/* Collapsed there is no room for words, so the count carries it: "+6". */}
      <span className="sidebar-nav__show-more-label">
        {isCollapsed ? (isExpanded ? "" : `+${hiddenCount.toString()}`) : label}
      </span>
    </button>
  );
};

export default SidebarShowMore;
